//Author Sooyoung Kim
//Date May 26, 2023
import {getReducer, getSetStateFunction, getAPICallGenerator, callBackGenerator, getSession, getRoles} from '../../../util/util';
import { Collapse } from 'reactstrap';
import {NavLink, useNavigate} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
import './side-bar.css';

//initialize the state
const initialState = {
  currentUrl: window.location.href?window.location.href:"",
  policyDropdownOpen: window.location.href.includes("client")?true:false,
  pipelineDropdownOpen: true,
  dashboardDropdownOpen: true,
  contactDropdownOpen: true,
  clientDropdownOpen: window.location.href.includes("client")?true:false,
  appraiserDropdownOpen: (window.location.href.includes("appraiser")||window.location.href.includes("amc"))?true:false,
  newAnnouncementCount:0,
};

//reducer function that perform state update
const reducer = getReducer();


const SideBar  = (props)=>{
  const history = useNavigate();
  const controller = new AbortController();
  let pipelinePreference = localStorage.getItem('pipelinePreference');

  let globalPipeline = false;
  if(pipelinePreference&&pipelinePreference!=='')
    if(pipelinePreference==='global')
      globalPipeline = true;

  let newInitialState = Object.assign({}, initialState, {globalPipeline:globalPipeline});

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    hasNewAnnouncement();

    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    setState({currentUrl:window.location.href});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[history]);

  //non API call but simpyl manage state

  const togglePipeline = ()=>{
    setState({
      pipelineDropdownOpen: !state.pipelineDropdownOpen
    });
  }

  const toggleContact=()=>{
    setState({
      contactDropdownOpen: !state.contactDropdownOpen
    });
  }

  //API call
  const hasNewAnnouncement = ()=>{
    let callBack = apiCallBack([{state:'newAnnouncementCount', key:'data.new_announcement_count'}]);
    httpGet('announcement/hasNewAnnouncement', '', '', callBack);
  }

  //render
  let count = <div style={{width:'10px'}} className="display-inline"></div>;
  if(state.newAnnouncementCount>0){
    count = <span className="my-badge" style={{fontSize:'11px'}}>{state.newAnnouncementCount}</span>
  }

  let appraisalLink = 'appraisal';
  let conditionLink = 'condition';
  let rebuttalLink = 'rebuttal';
  let dashboardLink = 'dashboard';

  if(state.globalPipeline){
    appraisalLink = 'appraisal-global';
    conditionLink = 'condition-global';
    rebuttalLink = 'rebuttal-global';
    dashboardLink = 'dashboard-global';
  }

  let roles = getRoles();
  let session = getSession();
  let userName = session.userFirstName+' '+session.userLastName;

  let adminSideBar, systemSettingBar;
  if(props.isLoggedIn){
    //only accessible by admin manager and super admin
    if(roles.indexOf('admin_manager')!==-1||roles.indexOf('super_admin')!==-1||roles.indexOf('admin')!==-1){
      adminSideBar =
      <li>
        <NavLink className={state.currentUrl.includes("/admin")?"padding sidebar-active-link":"padding"} to="/admin"><i className="fa-solid fa-user-tie sidebar-icon"></i> Admins</NavLink>
      </li>;

      systemSettingBar =
      <li>
        <NavLink className={state.currentUrl.includes("/system-setting")?"padding sidebar-active-link":"padding"} to="/system-setting"><i className="fa fa-gears sidebar-icon"></i> System Settings</NavLink>
      </li>
    }

    return (
      <div className="sidebar">
        <ul>
          <li>
            <NavLink className={window.location.href.includes("/announcement")?"padding sidebar-active-link":"padding"}  to="/announcement"><i className="fa fa-volume-up sidebar-icon"></i> Announcement {count}</NavLink>
          </li>
          <li className="collapse-nav">
            <NavLink to="/dashboard" className="padding"><i className="fa fa-dashboard sidebar-icon"></i> Dashboard</NavLink>
          </li>
          <li className="collapse-nav">
            <NavLink to="#" className="padding" onClick={togglePipeline}><i className="fa-solid fa-diagram-sankey sidebar-icon"></i> Pipeline <i className="fa fa-angle-double-down"></i></NavLink>
            <Collapse isOpen={state.pipelineDropdownOpen}>
            <NavLink className={state.currentUrl.includes("/appraisal")?"padding sidebar-active-link":"padding"} to={"/"+appraisalLink}>Appraisals</NavLink>
              <NavLink className={(state.currentUrl.includes("/condition") && !state.currentUrl.includes("/auto-condition"))?"padding sidebar-active-link":"padding"} to={"/"+conditionLink}>Conditions</NavLink>
              <NavLink className={state.currentUrl.includes("/rebuttal")?"padding sidebar-active-link":"padding"} to={"/"+rebuttalLink}>Rebuttals</NavLink>
            </Collapse>
          </li>

          <li className="collapse-nav">
            <NavLink className={state.currentUrl.includes("/setting")?"padding sidebar-active-link":"padding"} to="/setting"><i className="fa fa-gear sidebar-icon"></i> Settings</NavLink>
          </li>
          <li className="collapse-nav">
            <NavLink to="#" className="padding" onClick={toggleContact}><i className="fa-regular fa-address-card sidebar-icon"></i> Contact Us <i className="fa fa-angle-double-down"></i></NavLink>
            <Collapse isOpen={state.contactDropdownOpen}>
              <a className="padding" href={"mailto:service@homevms.com"}><i className="fa fa-envelope"></i>&nbsp;service@homevms.com</a>
              <a className="padding" href={"tel:(415)-614-3880"}><i className="fa fa-phone"></i>&nbsp;(415) 614 3880</a>
            </Collapse>
          </li>
        </ul>
      </div>
    );
  }
  else {
    return(null);
  }
}

export default SideBar;
